export default "__VITE_ASSET__CN5KbX0Y__"